/**
 * Metronome meters. Each meter is an accent pattern: one entry per click in the
 * bar, giving that click's stress. The metronome clicks at the BPM rate and
 * cycles the pattern, so odd and additive meters (5/4, 7/8, Balkan 2+2+2+3,
 * Indian talas) are expressed simply as which pulses are accented.
 */

/** 0 = weak, 1 = medium (secondary accent), 2 = strong (downbeat). */
export type AccentLevel = 0 | 1 | 2;

export interface Meter {
  readonly id: string;
  readonly label: string;
  readonly accents: readonly AccentLevel[];
}

export const METERS: readonly Meter[] = [
  { id: '4/4', label: '4/4 (comună)', accents: [2, 0, 1, 0] },
  { id: '3/4', label: '3/4 (vals)', accents: [2, 0, 0] },
  { id: '2/4', label: '2/4', accents: [2, 0] },
  { id: '6/8', label: '6/8 (3+3)', accents: [2, 0, 0, 1, 0, 0] },
  { id: '5/4', label: '5/4 (Take Five · 3+2)', accents: [2, 0, 0, 1, 0] },
  { id: '7/8', label: '7/8 (2+2+3)', accents: [2, 0, 1, 0, 1, 0, 0] },
  { id: '9/8', label: '9/8 (Balcanic · 2+2+2+3)', accents: [2, 0, 1, 0, 1, 0, 1, 0, 0] },
];

export const CUSTOM_METER_ID = 'custom';

const byId = new Map(METERS.map((m) => [m.id, m]));

/** The accent pattern for the current meter selection. */
export function accentsFor(meterId: string, custom: readonly AccentLevel[]): readonly AccentLevel[] {
  if (meterId === CUSTOM_METER_ID) return custom.length > 0 ? custom : [2];
  return byId.get(meterId)?.accents ?? [2, 0, 1, 0];
}
